<template>
  <v-app>
    <v-app-bar clipped-left dark color="primary" app>
      <v-app-bar-nav-icon @click="drawer = !drawer" v-if="organizationUUID"></v-app-bar-nav-icon>
      <v-btn icon>
        <v-img max-width="30" src="https://cdn.salescloud.is/logo_white.svg" />
      </v-btn>
      <v-toolbar-title class="white--text">eTag Builder</v-toolbar-title>
      <v-spacer></v-spacer>
      <div style="font-size: 0.8rem;">{{ version }}</div>
    </v-app-bar>

    <v-row v-if="loading" align="center" >
      <v-col cols="12">
        <v-row justify="center">
          <v-progress-circular
              indeterminate
              color="primary"
          ></v-progress-circular>
        </v-row>
        <v-row justify="center">
          <div class="regular mt-3">Fetching organization data.</div>
        </v-row>
      </v-col>
      <v-footer absolute>
        <v-col align="center" cols="12">
          <div class="subtitle-2">
            Created by <a target="_blank" href="https://www.salescloud.is" style="text-decoration:
          none;">SalesCloud</a>
          </div>
          <div class="caption">
            SalesCloud provides secure checkout and payment processing.
          </div>
        </v-col>
      </v-footer>
    </v-row>

    <v-row v-if="!loading && organizationUUID && !organization" align="center" justify="center">
      <v-col md="8">
        <v-alert
            prominent
            type="error"
        >
          <v-row justify="center">
              <div>Unable to fetch organization data.</div>
          </v-row>
          <v-row justify="center">
            <div class="caption">Please review your link.</div>
          </v-row>
        </v-alert>
      </v-col>
      <v-footer absolute>
        <v-col align="center" cols="12">
          <div class="subtitle-2">
            Created by <a target="_blank" href="https://www.salescloud.is" style="text-decoration:
          none;">SalesCloud</a>
          </div>
          <div class="caption">
            SalesCloud provides secure checkout and payment processing.
          </div>
        </v-col>
      </v-footer>
    </v-row>

    <v-navigation-drawer
        v-if="organizationUUID && !loading"
        clipped app v-model="drawer" width="350" bottom mobile-break-point="800">
      <Drawer />
    </v-navigation-drawer>

    <v-content app v-if="organization && organization.label && !loading">
      <router-view></router-view>
    </v-content>

  </v-app>
</template>

<script>
import Drawer from './views/Drawer.vue'

import { version } from '../package.json'

export default {
  name: 'app',
  components: {
    Drawer,
  },
  data() {
    return {
      drawer: true,
      message: '',
      subMessage: '',
      version: version
    }
  },
  created() {
    // console.log('app created')
    let organizationUUID = this.$route.query.organizationUUID

    if(!organizationUUID) {
      this.message = 'Unable to fetch organization data.'
      this.subMessage = 'Please review your link.'
    } else {
      this.$store.commit('setOrganizationUUID', organizationUUID)
      this.$store.dispatch('getInitialData', organizationUUID)
    }

  },
  computed: {
    loading: function() {
      return this.$store.state.loading
    },
    values: function() {
      return this.$store.getters.values
    },
    organizationUUID: function() {
      return this.$store.state.organizationUUID
    },
    organization: function() {
      return this.$store.state.organization
    },
  }
}
</script>
